import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PolonyApp from './polony/PolonyApp';
import HomePage from './home/HomePage';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/app" element={<PolonyApp />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
